// src/pages/News.js
import React, { useState, useEffect } from 'react';
import '../styles/news.css';

function News() {
    const [newsStories, setNewsStories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                setIsLoading(true);
                setError(null);

                // Fetch from CryptoCompare API
                const response = await fetch('https://min-api.cryptocompare.com/data/v2/news/?lang=EN');
                if (!response.ok) {
                    throw new Error(`CryptoCompare API failed with status: ${response.status}`);
                }
                const data = await response.json();
                const formattedNews = data.Data.slice(0, 16).map(article => ({
                    date: new Date(article.published_on * 1000).toLocaleDateString(),
                    title: article.title,
                    image: article.imageurl || 'https://via.placeholder.com/150',
                }));
                setNewsStories(formattedNews);
                console.log('News fetched successfully:', formattedNews);
            } catch (error) {
                console.error('Fetch error details:', error.message);
                setError(`Failed to load news stories. Please try again later. Details: ${error.message}`);
            } finally {
                setIsLoading(false);
            }
        };

        fetchNews();
    }, []);

    return (
        <div className="news-page">
            <div className="news-content">
                <h1>Top Stories</h1>
                {isLoading ? (
                    <p className="loading">Loading news...</p>
                ) : error ? (
                    <p className="error">{error}</p>
                ) : (
                    <div className="news-grid">
                        {newsStories.map((story, index) => (
                            <div key={index} className="news-card">
                                <div className={`news-date ${index % 2 === 0 ? 'orange' : 'blue'}`}>
                                    {story.date}
                                </div>
                                <div className="news-image">
                                    <img src={story.image} alt={story.title} />
                                </div>
                                <div className="news-title">{story.title}</div>
                            </div>
                        ))}
                    </div>
                )}
                <p className="news-source">Daily cryptocurrency news by TradingView</p>
            </div>
        </div>
    );
}

export default News;